var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#4353FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5251 10.5751L14.4376 14.0026C14.4376 13.7401 13.6876 8.05505 13.6876 8.05505C11.9626 8.05505 11.0476 9.27755 10.5676 10.5751L9.24008 14.0101C9.24008 13.7626 9.05258 10.6051 9.05258 10.6051C8.98855 9.92152 8.67606 9.2852 8.17431 8.81663C7.67256 8.34805 7.01639 8.07975 6.33008 8.06255L7.74008 16.6726C9.54008 16.6726 10.5151 15.4501 11.0176 14.1526L12.1426 11.2276C12.1426 11.3476 12.8926 16.6726 12.8926 16.6726C13.6286 16.6716 14.3452 16.4363 14.9386 16.0007C15.5319 15.5652 15.9711 14.952 16.1926 14.2501L18.7426 8.05505C16.9426 8.05505 15.9976 9.27755 15.5176 10.5751H15.5251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowIcon);
export default __webpack_public_path__ + "static/media/webflow-icon.808e7186f61cb87bd5997b9d3e04a157.svg";
export { ForwardRef as ReactComponent };